import CryptoJS from 'crypto-js';

const secret_key = process.env.REACT_APP_PUBLIC_SECRET_KEY;
const iv_key = process.env.REACT_APP_PUBLIC_SECRET_IV;

const ENCRYPTION_KEY = secret_key;
const IV = CryptoJS.enc.Utf8.parse(iv_key);

export function encryptData(data) {
  const encrypted = CryptoJS.AES.encrypt(JSON.stringify(data), CryptoJS.enc.Utf8.parse(ENCRYPTION_KEY), {
    iv: IV,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encrypted.toString();
}